import { useEffect, useRef } from "react";
import { api } from "@/lib/api";

const KEY = "tierpt_session_id";

function getOrMakeSessionId() {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id =
        (crypto.randomUUID && crypto.randomUUID()) ||
        `s-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return `s-${Date.now()}`;
  }
}

export default function VisitTracker() {
  const fired = useRef(false);
  useEffect(() => {
    if (fired.current) return;
    fired.current = true;
    try {
      // patch 39b: every time the site is opened counts (Admin "Visitors"); moving between pages doesn't
      const sid = getOrMakeSessionId();
      api
        .post("/track-visit", {
          session_id: sid,
          path: typeof window !== "undefined" ? window.location.pathname : "",
        })
        .catch(() => {});
    } catch {}
  }, []);
  return null;
}
